import React from "react";
import { basicValidation, CommandResult, fieldValidation } from "../../../amorg-common";
import { forgiveWhitespaceAndCase } from '../../../amorg-common/util/stringUtil';
import { requestPasswordReset } from "../../../api/userClientApi";
import { Button } from "../../../designSystem/button/Button";
import { ButtonRow } from "../../../designSystem/button/ButtonRow";
import { Card } from '../../../designSystem/Card';
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { TextField } from "../../../designSystem/formField/text/TextField";
import { SingleColumnLayout } from "../../../designSystem/layouts/SingleColumnLayout";
import { MessageCard } from "../../../designSystem/Message";
import { PageHeader } from "../../../designSystem/PageHeader";
import { P } from "../../../designSystem/typography/Body";

type PasswordResetPanelProps = {
    header:string,
    helpText:string,
    isSetup?:boolean
}
export function PasswordResetPanel(props:PasswordResetPanelProps):JSX.Element
{
    const [state, setState] = React.useState<{
        hasExecuted: boolean,
        result: CommandResult;
    }>({ hasExecuted: false, result: undefined });

    const [site, setSite] = React.useState('');
    const [email, setEmail] = React.useState('');

    async function submit ()
    {
        const result = await requestPasswordReset(
            forgiveWhitespaceAndCase(site), 
            forgiveWhitespaceAndCase(email), 
            props.isSetup === true
        );
        setState({ hasExecuted: true, result });
    }

    return (
        <SingleColumnLayout
            noDivider
            headerContainer={
                <PageHeader headerText={props.header} headerStyle="secondary-gray" />
            }
            contentContainer={
                <Flex flexDirection='column' gap={24} width="600px">

                    <Card variant="outlined">
                        <P>{props.helpText}</P>
                    </Card>
                
                    {state.hasExecuted &&
                        <>
                            {state.result.isSuccess
                                ?
                                <MessageCard variant={'success'}>
                                    Vi har sendt en e-mail til den indtastede addresse. Følg anvisningerne i e-mailen for at oprette en ny adgangskode.
                                </MessageCard>
                                :
                                <MessageCard variant={'error'}>
                                    Der findes ikke en gyldig bruger med de indtastede oplysninger.
                                </MessageCard>
                            }
                        </>
                    }

                    <TextField
                        label="Organisation"
                        value={site}
                        onChange={(value) => setSite(value)}
                        disabled={state.result?.isSuccess}
                        validator={(value) => !state.hasExecuted || fieldValidation.site.id(value)
                            ? { valid: true }
                            : { valid: false, errorMessage: 'Skal udfyldes' }
                        } />

                    <TextField
                        label="E-mail"
                        value={email}
                        onChange={(value) => setEmail(value)}
                        disabled={state.result?.isSuccess}
                        validator={(value) => !state.hasExecuted || basicValidation.isValidEmail(value)
                            ? { valid: true }
                            : { valid: false, errorMessage: 'Skal være en gyldig email adresse' }
                        } />

                    <ButtonRow>
                        <Button variant="filled"
                            disabled={state.result?.isSuccess || (site === '' || !basicValidation.isValidEmail(email))}
                            onClick={submit}
                            text={props.isSetup ? "Opret adgangskode" : "Gendan adgangskode"} />
                    </ButtonRow>
                </Flex>

            }
        />
    );
}